import * as React from 'react';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { Hooks } from '@grandvisionhq/stores-v2';
import { getServiceStore } from '../../../selectors.js';
import { selectServiceStore } from '../../../StepShipping/actions.js';
import { StoreSummary } from '../components/StoreSummary.js';

const StoreSummaryContainer = ({ globalStoreId: globalStoreId1 , actions , resetServiceStore , className  })=>{
    const dispatch = useDispatch();
    const [getStoreById, storeById] = Hooks.useStoreById();
    const serviceStore = useSelector(getServiceStore);
    React.useEffect(()=>{
        if (globalStoreId1 && (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.globalStoreId) !== globalStoreId1) {
            getStoreById({
                variables: {
                    globalStoreId: globalStoreId1
                }
            });
        }
    }, [
        globalStoreId1,
        getStoreById,
        serviceStore
    ]);
    React.useEffect(()=>{
        if (storeById.error) {
            dispatch(selectServiceStore({
                serviceStore: null
            }));
            resetServiceStore && resetServiceStore();
            return;
        }
        if (storeById.data && storeById.data.globalStoreId !== (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.globalStoreId)) {
            const { globalStoreId , name , streetName , streetNumber , town  } = storeById.data;
            const newServiceStore = {
                globalStoreId,
                name,
                streetName,
                streetNumber,
                town
            };
            dispatch(selectServiceStore({
                serviceStore: newServiceStore
            }));
        }
    }, [
        dispatch,
        resetServiceStore,
        serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.globalStoreId,
        storeById.data,
        storeById.error
    ]);
    if (!serviceStore) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreSummary, {
        className: className,
        name: serviceStore.name,
        streetName: serviceStore.streetName,
        streetNumber: serviceStore.streetNumber,
        actions: actions
    });
};

export { StoreSummaryContainer };
//# sourceMappingURL=StoreSummaryContainer.js.map
